import React from "react";
import { FiMessageSquare } from "react-icons/fi";

interface ClarificationEmptyStateProps {
  isClientView: boolean;
}

export const ClarificationEmptyState: React.FC<ClarificationEmptyStateProps> = ({
  isClientView,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
        <FiMessageSquare className="h-6 w-6 text-gray-400" />
      </div>
      <h3 className="mb-1 text-sm font-medium text-gray-900">No clarifications yet</h3>
      <p className="text-sm text-gray-500">
        {isClientView
          ? "Create a clarification via a suppliers submission to request additional information."
          : "No clarification requests have been received for this submission."}
      </p>
    </div>
  );
};
